export default "__VITE_ASSET__DRq8Xc1E__"